function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20.5 16.674c-.464 1.04-.687 1.506-1.284 2.425-.835 1.284-2.012 2.887-3.467 2.897-1.295.012-1.63-.854-3.389-.839-1.757.009-2.123.856-3.42.843-1.457-.014-2.57-1.457-3.406-2.74C3.2 15.665 2.952 11.45 4.395 9.208c1.022-1.59 2.636-2.524 4.153-2.524 1.546 0 2.517.858 3.794.858 1.24 0 1.994-.86 3.782-.86 1.35 0 2.778.744 3.8 2.028-3.34 1.851-2.797 6.673.576 7.964zM14.766 5.247c.65-.844 1.144-2.034.964-3.247-1.06.073-2.3.757-3.024 1.644-.656.808-1.2 2.007-.99 3.167 1.158.038 2.356-.66 3.05-1.564z"
});

function SvgAppleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgAppleinline;